<template>
  <div>
  <!-- Nav menu with side menu -->
  <nav class="mb-4 navbar navbar-expand-lg navbar-dark cyan">
   <img src="@/assets/logo.png" width="30" height="30" alt="">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent-4" aria-controls="navbarSupportedContent-4" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul  class="navbar-nav mr-auto" style="padding-left: 20px">
      <li class="nav-item active">
        <a class="nav-link" href="/start">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="/start">Link</a>
      </li>
    </ul>
    <div class="collapse navbar-collapse" id="navbarSuapportedContent-4">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" id="navbarDropdownMenuLink-4" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-user"></i> Profile </a>
          <div class="dropdown-menu dropdown-menu-right dropdown-cyan" aria-labelledby="navbarDropdownMenuLink-4">
            <a class="dropdown-item" href="#">Mi cuenta</a>
            <a class="dropdown-item" href="/signIn">Cerrar Sesion</a>
            <router-link class="dropdown-item" :to="{name: 'fav'}">Favoritos</router-link>
          </div>
        </li>
      </ul>
    </div>
  </nav>
  <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'HomeView',
  components: {

  }
}
</script>
